import type { CSSProperties } from "react";
import "./ProductDomPoster.css";

type Props = {
  productName: string;
  intro?: string | null;
  className?: string;
  /** 装饰性海报对读屏隐藏；订单详情等需保留语义时可传 false */
  decorative?: boolean;
};

const GRADIENT_PRESETS = [
  {
    bg: "linear-gradient(135deg, #1e1b4b 0%, #4c1d95 38%, #be185d 72%, #f97316 100%)",
    orb1: "rgba(251, 191, 36, 0.42)",
    orb2: "rgba(56, 189, 248, 0.35)",
    accent: "#fbbf24",
  },
  {
    bg: "linear-gradient(135deg, #0f172a 0%, #1d4ed8 42%, #7c3aed 78%, #ec4899 100%)",
    orb1: "rgba(244, 114, 182, 0.4)",
    orb2: "rgba(34, 211, 238, 0.32)",
    accent: "#22d3ee",
  },
  {
    bg: "linear-gradient(135deg, #042f2e 0%, #0f766e 40%, #2563eb 74%, #a855f7 100%)",
    orb1: "rgba(52, 211, 153, 0.38)",
    orb2: "rgba(250, 204, 21, 0.34)",
    accent: "#34d399",
  },
  {
    bg: "linear-gradient(135deg, #450a0a 0%, #b91c1c 36%, #c026d3 70%, #f59e0b 100%)",
    orb1: "rgba(253, 224, 71, 0.36)",
    orb2: "rgba(251, 113, 133, 0.34)",
    accent: "#fde047",
  },
] as const;

function pickPreset(seed: string) {
  let hash = 0;
  for (let i = 0; i < seed.length; i += 1) {
    hash = (hash * 31 + seed.charCodeAt(i)) >>> 0;
  }
  return GRADIENT_PRESETS[hash % GRADIENT_PRESETS.length];
}

/** 无上传海报时，用产品名称与介绍渲染固定 DOM 模板海报 */
export function ProductDomPoster(props: Props): JSX.Element {
  const name = props.productName.trim() || "会员产品";
  const intro = props.intro?.trim() ?? "";
  const preset = pickPreset(name);
  const rootClass = ["product-dom-poster", props.className].filter(Boolean).join(" ");

  return (
    <div
      className={rootClass}
      style={
        {
          "--product-dom-poster-bg": preset.bg,
          "--product-dom-poster-orb-1": preset.orb1,
          "--product-dom-poster-orb-2": preset.orb2,
          "--product-dom-poster-accent": preset.accent,
        } as CSSProperties
      }
      aria-hidden={props.decorative === false ? undefined : true}
    >
      <div className="product-dom-poster__bg" />
      <div className="product-dom-poster__grid" />
      <div className="product-dom-poster__orb product-dom-poster__orb--1" />
      <div className="product-dom-poster__orb product-dom-poster__orb--2" />
      <div className="product-dom-poster__frame" />
      <div className="product-dom-poster__content">
        <h2 className="product-dom-poster__title">{name}</h2>
        {intro ? <p className="product-dom-poster__intro">{intro}</p> : null}
      </div>
      <div className="product-dom-poster__shine" />
    </div>
  );
}
